import { select, put, takeLatest, all } from 'redux-saga/effects';
import { privateCall } from './api.saga';

import { appActions } from '../reducers/app.reducer';

import ReactGA from 'react-ga';

function* boot() {
	try {
		const endpoint = yield select(s => s.config.endpoints.init);
		const { navigation, pages, popups, contacts } = yield privateCall({ endpoint });

		const pagesObj = {};
		Object.values(pages).forEach(x => {
			pagesObj[x.internalUrl] = x;
		});

		// localStorage.setItem('init', JSON.stringify({ navigation, pages: pagesObj, popups, contacts }));

		yield put(appActions.booted({
			navigation,
			pages: pagesObj,
			popups,
			contacts,
		}));
	} catch (e) {}
}

function* gaPageView({ payload: { pathname } }) {
	try {
		const { clientEnv } = yield select(s => s.app);

		if (clientEnv === 'prod')
			ReactGA.pageview(pathname === '/' ? pathname : pathname.replace(/\/$/, ''));
	} catch (e) {}
}

function* gaEvent({ payload }) {
	try {
		const clientEnv = yield select(s => s.app.clientEnv);

		if (clientEnv === 'prod')
			ReactGA.event(payload);
	} catch (e) {}
}

function* contactUsBubble({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.contactUsBubble);
		yield privateCall({ endpoint, payload, method: 'post' });
	} catch (e) {}
}

export default function* appSaga() {
	yield all([
		yield takeLatest(appActions.boot, boot),
		yield takeLatest(appActions.gaPageView, gaPageView),
		yield takeLatest(appActions.gaEvent, gaEvent),
		yield takeLatest(appActions.contactUsBubble, contactUsBubble),
	]);
}
